<div class="unit-container">
  <div class="unit">
    <div class="stepper-veritical">
      <app-step 
        [ngStyle]="{'margin-bottom': '20px'}"
        [type]="2" [stepperData]="listStepsVertical" 
        (sendData)="getClick($event._selectedIndex)"
        (sendStepperList)="updateStepper($event)"></app-step>
        <button class="btn-back" (click)="routerBack()">Voltar</button>
    </div>
    <div class="unit-form">
      <div class="stepper-horizontal">
        <div class="stepper-title">
          <h3>Força do cadastro: básica</h3>
          <img src="../../../assets/svgs/i_lamp.svg" alt="Icon">
        </div>
        <div class="stepper-scroll">
          <app-step [type]="1" [listStepper]="listStepper"></app-step>
        </div>
        <div class="tabs">
          <lib-tabs [tabs]="tabs" [tabAlign]="2"></lib-tabs>
        </div>
      </div>
      <router-outlet></router-outlet>
    </div>
    <div class="margin-right"></div>
  </div>
</div>